var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 2H15V0.5C15 0.2 14.8 0 14.5 0C14.2 0 14 0.2 14 0.5V2H5V0.5C5 0.2 4.8 0 4.5 0C4.2 0 4 0.2 4 0.5V2H0.5C0.2 2 0 2.2 0 2.5V18.5C0 18.8 0.2 19 0.5 19H18.5C18.6 19 18.6 19 18.7 19C18.9 18.9 19 18.7 19 18.5V2.5C19 2.2 18.8 2 18.5 2ZM18 18H1V7H18V18ZM18 6H1V3H4V4.5C4 4.8 4.2 5 4.5 5C4.8 5 5 4.8 5 4.5V3H14V4.5C14 4.8 14.2 5 14.5 5C14.8 5 15 4.8 15 4.5V3H18V6ZM5 10H4V11H5V10ZM15 10H14V11H15V10ZM13 10H12V11H13V10ZM7 10H6V11H7V10ZM11 10H10V11H11V10ZM9 10H8V11H9V10ZM5 12H4V13H5V12ZM15 12H14V13H15V12ZM13 12H12V13H13V12ZM7 12H6V13H7V12ZM11 12H10V13H11V12ZM9 12H8V13H9V12ZM5 14H4V15H5V14ZM15 14H14V15H15V14ZM13 14H12V15H13V14ZM7 14H6V15H7V14ZM11 14H10V15H11V14ZM9 14H8V15H9V14Z",
    fill: "#90A4AE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.002797fb6570055abb4ad413858ed77a.svg";
export { ForwardRef as ReactComponent };